export default "__VITE_ASSET__0ae244ac__"